import { css } from "lit";

export const styles = css`
  :host {
    display: block;
  }

  .preview-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 650px;
    margin: 0 auto;
  }

  @media (max-width: 767px) {
    .preview-content {
      width: 100%;
      min-height: calc(100dvh - 120px); /* Full height minus header and padding */
      justify-content: space-between;
    }
  }

  .event-preview-card {
    overflow: hidden;
    border-radius: var(--sds-size-radius-600);
    border: 1px solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
    width: 100%;
  }

  .event-thumbnail-container {
    position: relative;
    width: 100%;
    height: 180px;
    border-radius: var(--sds-size-radius-400) var(--sds-size-radius-400) 0 0;
    background:
      linear-gradient(61deg, rgba(17, 17, 17, 0) 81.18%, #111 107.94%),
      linear-gradient(202deg, rgba(17, 17, 17, 0) 25.48%, #111 74.88%),
      var(--bg-image) lightgray center / cover no-repeat;
  }

  .event-thumbnail-container.no-image {
    background: linear-gradient(180deg, var(--sds-color-gray-900) 0%, var(--sds-color-gray-1000) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .no-image-placeholder {
    color: var(--sds-color-text-default-tertiary);
    font-size: 48px;
    opacity: 0.5;
  }

  .price-badge {
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 1;
    --badge-icon-color: var(--theme-primary-color, var(--sds-color-text-brand-on-brand));
  }

  .spots-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 1;
    --badge-icon-color: var(--theme-primary-color, var(--sds-color-text-brand-on-brand));
  }

  .event-info-overlay {
    position: absolute;
    bottom: 12px;
    left: 12px;
    right: 12px;
  }

  .event-title {
    color: #fff;
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-subheading-size);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 120%;
    margin: 0 0 4px 0;
    text-shadow: 0 1px 3px rgb(0 0 0 / 0.5);
  }

  .event-datetime {
    color: var(--theme-primary-color, var(--sds-color-text-brand-on-brand));
    font-family: var(--sds-typography-family-body);
    font-size: 12px;
    font-weight: 400;
    line-height: 100%;
    text-shadow: 0 1px 3px rgb(0 0 0 / 0.5);
  }

  .event-details {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .event-description {
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 140%;
  }

  .cta-button {
    width: 100%;
    display: flex;
    height: 48px;
    padding: var(--sds-size-space-600) var(--sds-size-space-400);
    justify-content: center;
    align-items: center;
    gap: var(--sds-size-space-200);
    border: none;
    border-radius: var(--sds-size-radius-400);
    background: var(--theme-primary-color, var(--sds-color-background-brand-default));
    color: var(--sds-color-text-neutral-on-neutral);
    cursor: default;
    pointer-events: none;
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-semibold);
    line-height: 100%;
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding-top: 24px;
    border-top: 1px solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-default);
  }

  .action-buttons wow-button {
    --wow-button-display: block;
    --wow-button-width: 100%;
    --wow-button-inner-display: flex;
    --wow-button-inner-width: 100%;
  }
`;
